var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ShareSvg = /* @__PURE__ */ __name(function ShareSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M25.047 13.907c-3.827 0-6.929-3.102-6.929-6.929s3.102-6.929 6.929-6.929c3.827 0 6.929 3.102 6.929 6.929v0c-0.020 3.819-3.11 6.909-6.927 6.929h-0.002zM25.047 2.474c-2.46 0-4.454 1.994-4.454 4.454s1.994 4.454 4.454 4.454c2.46 0 4.454-1.994 4.454-4.454v0c-0.017-2.453-2.001-4.437-4.452-4.454h-0.002z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M5.998 26.759c-3.313 0-5.998-2.685-5.998-5.998s2.685-5.998 5.998-5.998c3.313 0 5.998 2.685 5.998 5.998v0c-0.003 3.312-2.687 5.995-5.998 5.998h-0zM5.998 17.237c-1.946 0-3.524 1.578-3.524 3.524s1.578 3.524 3.524 3.524c1.946 0 3.524-1.578 3.524-3.524v0c-0.003-1.945-1.579-3.521-3.523-3.524h-0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M23.621 32c-2.788 0-5.048-2.26-5.048-5.048s2.26-5.048 5.048-5.048c2.788 0 5.048 2.26 5.048 5.048v0c-0.003 2.787-2.261 5.045-5.048 5.048h-0zM23.621 24.379c-1.421 0-2.573 1.152-2.573 2.573s1.152 2.573 2.573 2.573c1.421 0 2.573-1.152 2.573-2.573v0c-0.003-1.42-1.153-2.571-2.573-2.573h-0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9.822 23.814l0.919-2.298 9.526 3.81-0.919 2.298-9.526-3.81z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9.144 16.383l10.478-6.672 1.329 2.087-10.478 6.672-1.329-2.087z"
  }));
}, "ShareSvg");
var ShareIcon = /* @__PURE__ */ __name(function ShareIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ShareSvg
  }, props));
}, "ShareIcon");
export {
  ShareIcon
};
